import React from 'react';
import PropTypes from 'prop-types';
import { View, Platform, TouchableOpacity } from 'react-native';
import Text from '../text';
import { StylePropType } from '../../../utils/prop-types';
import styles from './button-view.styles';
import Spinner from '@dbk/ui-spinner';

function Button({ disabled, inline, size, style, title, transparent, onClick, onPress, className, children, ...props }) {
    const onClickFunc = onClick || onPress;

    const maybeSpinner =
        props.loading ? (
            <Spinner
                style={styles.loadingSpinner}
                size="medium"
                stroke={1}
                inner
                type={props.type}
                velocity={12}
                secondary={props.secondary}
                tertiary={props.tertiary}
            />
        ) : null;


    return (
        <div>
            <div className={'btn-width'}>
                <TouchableOpacity
                    accessibilityComponentType="button"
                    accessibilityTraits="button"
                    onPress={onClickFunc}
                    style={disabled ? styles.touchableOpacityDisabled : styles.touchableOpacityEnabled}
                    disabled={disabled}>
                    <View style={styles.content}>
                        <Text style={disabled ? styles.textDisabled : styles.textEnabled}>
                            {children}
                        </Text>
                        {maybeSpinner && <View style={styles.loadingSpinner}>{maybeSpinner}</View>}
                    </View>
                </TouchableOpacity>
            </div>
        </div>
    );
}

Button.propTypes = {
    inline: PropTypes.bool,
    disabled: PropTypes.bool,
    size: Text.propTypes.size,
    style: StylePropType,
    title: PropTypes.string,
};

Button.defaultProps = {
    inline: false,
    size: 'normal',
};

export default Button;
